export default "__VITE_ASSET__C6pl3Jdn__"